import { Reducer } from "redux";
import {

FETCH_DEPARTMENT_TEACHERS_REQUEST,
FETCH_DEPARTMENT_TEACHERS_SUCCESS,
FETCH_DEPARTMENT_TEACHERS_FAILURE,
FETCH_DEPARTMENT_STUDENTS_REQUEST,
FETCH_DEPARTMENT_STUDENTS_SUCCESS,
FETCH_DEPARTMENT_STUDENTS_FAILURE,
FETCH_MY_STUDENTS_REQUEST,
FETCH_MY_STUDENTS_SUCCESS,
FETCH_MY_STUDENTS_FAILURE,
DepartmentDataActionTypes,
} from '../actions/getDepartmentDataAction';

interface DepartmentDataState {
departmentTeachers: any[];
departmentStudents: any[];
departmentTeachersCount: number;
departmentStudentsCount: number;
myStudentsCount:         number;
myStudents: any[];
loading: boolean;
error: string | null;
}

const initialState: DepartmentDataState = {
departmentTeachers: [],
departmentStudents: [],
myStudents: [],
departmentTeachersCount: 0,
departmentStudentsCount: 0,
myStudentsCount:         0,  
loading: false,
error: null,
};

const getDepartmentDataReducer = (
state = initialState,
action: DepartmentDataActionTypes
): DepartmentDataState => {
switch (action.type) {
    case FETCH_DEPARTMENT_TEACHERS_REQUEST:
    case FETCH_DEPARTMENT_STUDENTS_REQUEST:
    case FETCH_MY_STUDENTS_REQUEST:
        return {
            ...state,
            loading: true,
            error: null,
        };

case FETCH_DEPARTMENT_TEACHERS_SUCCESS:
  return {
    ...state,
    loading: false,
    departmentTeachers: action.payload,
    departmentTeachersCount: action.count,
    error: null,
  };

case FETCH_DEPARTMENT_STUDENTS_SUCCESS:
  return {
    ...state,
    loading: false,
    departmentStudents: action.payload,
    departmentStudentsCount: action.count,
    error: null,
  };

case FETCH_MY_STUDENTS_SUCCESS:
  return {
    ...state,
    loading: false,
    myStudents: action.payload,
    myStudentsCount: action.count, 
    error: null,
  };

    case FETCH_DEPARTMENT_TEACHERS_FAILURE:
    case FETCH_DEPARTMENT_STUDENTS_FAILURE:
    case FETCH_MY_STUDENTS_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        };

    default:
        return state;
}
};

// Redux 5 types actions as UnknownAction; cast keeps internal narrowing intact
export default getDepartmentDataReducer as Reducer<DepartmentDataState>;